import { toast } from "sonner";

// Any "daily limit reached" error that a pack can lift gets a "Get more" button, wherever it's shown
const original = toast.error;
toast.error = (msg, opts) => (typeof msg === "string" && msg.includes("extra allowance pack")
  ? original(msg, { ...opts, id: "ai-limit", duration: 12000, action: { label: "Get more", onClick: () => window.location.assign("/more-ai") } })
  : original(msg, opts));
